// extracted by mini-css-extract-plugin
export default {"tabs-list":"components-hotel-and-market-navigation-navigation-main-tabs-module__tabs-list"};